import Header from "@/components/Header";
import Hero from "@/components/Hero";
import FeaturesOverview from "@/components/FeaturesOverview";
import AIToolsSection from "@/components/AIToolsSection";
import BlogSection from "@/components/BlogSection";
import NotebooksSection from "@/components/NotebooksSection";
import PapersSection from "@/components/PapersSection";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Hero />
      <FeaturesOverview />
      <AIToolsSection />
      <BlogSection />
      <NotebooksSection />
      <PapersSection />
      <CTASection />
      <Footer />
    </div>
  );
}
